module.exports = __webpack_public_path__ + "img/list-pointers-svgrepo-com.e968acc4.svg";